// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3jAbZ","insightsList":"newBusinessInsightsMenu_insightsList__3f9Ij","active":"newBusinessInsightsMenu_active__NtZyt"};